import { useEffect, useState } from 'react'
import {
  Heading,
  Stack,
  VStack,
  Button,
  Text,
  useMediaQuery,
  Image,
  Box,
  Divider
} from '@chakra-ui/react'
import 'react-datepicker/dist/react-datepicker.css'
import { useNavigate } from 'react-router-dom'

import ListDistributor from '../../components/ListDistributor'
import SelectWeb from '../../components/SelectWeb'
import DateDrawer from '../../components/DateDrawer'
import ListChannel from '../../components/ListChannel'
import useDistributor from '../../hooks/useDistributor'
import useChannel from '../../hooks/useChannel'
import useAuth from '../../hooks/useAuth'
import clientAxios from '../../config/axios'

const quilmesImages = require.context('../../assets/images', true)

function SurveyInformation () {
  const { userRegister } = useAuth()
  const { preferences } = userRegister

  const [error, setError] = useState('')
  const [survey, setSurvey] = useState({
    date: new Date(),
    distributor: preferences === null ? '' : preferences.distributor.description,
    // area: '',
    // bottler: '',
    channel: preferences === null ? '' : preferences.channel.description,
    idDistributor: preferences === null ? '' : preferences.distributor.distributorId,
    // idArea: '',
    // idBottler: '',
    idChannel: preferences === null ? '' : preferences.channel.channelId
  })
  const [data, setData] = useState({})
  const navigate = useNavigate()
  const [distributors] = useDistributor()
  const [channels] = useChannel()
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')

  const sizes = ['full']

  /* Setting the date in the data object. */
  useEffect(() => {
    if (survey.date === '') {
      return
    }
    setData({
      date: survey.date,
      distributor: survey.distributor,
      channel: survey.channel,
      idDistributor: survey.idDistributor,
      idChannel: survey.idChannel
    })
  }, [survey])

  /* Destructuring the survey object. */
  const { date, distributor, channel } = survey

  /* Setting the idDistributor in the survey object. */
  useEffect(() => {
    distributors.forEach(item => {
      if (item.description === distributor) {
        sessionStorage.setItem('bottlerSelect', JSON.stringify(item.bottler))
        sessionStorage.setItem('geoAreaSelect', JSON.stringify(item.geoArea))
        setSurvey({
          ...survey,
          idDistributor: item.distributorId
        })
      }
    })
  }, [distributor])

  useEffect(() => {
    const cargandoUser = async () => {
      const dataUser = await sessionStorage.getItem('user')

      const user = JSON.parse(dataUser)

      if (user.preferences !== null) {
        sessionStorage.setItem('bottlerSelect', JSON.stringify(user.preferences.bottler))
        sessionStorage.setItem('geoAreaSelect', JSON.stringify(user.preferences.geoArea))
      }
    }

    cargandoUser()
  }, [])

  /* Setting the idChannel in the survey object. */
  useEffect(() => {
    channels.forEach(item => {
      if (item.description === channel) {
        setSurvey({
          ...survey,
          idChannel: item.channelId
        })
      }
    })
  }, [channel])

  /**
 * It prevents the default behavior of the form, checks if the form is empty, and if it is, it sets an
 * error message, and if it isn't, it saves the data in the session storage and navigates to the next
 * page
 * @param e - event
 * @returns The data is being returned in the form of a JSON object.
 */
  const handleSubmit = (e) => {
    e.preventDefault()

    if ([date, distributor, channel].includes('')) {
      setError('Es necesario que completes todos los campos')

      setTimeout(() => {
        setError('')
      }, 3000)

      return
    }

    data.date = data.date.toLocaleDateString()
    // reverse data.date y colocar en ves / colocar -
    let dateNew = data.date.split('/')

    if (dateNew[1] < 10) {
      dateNew[1] = '0' + dateNew[1]
    }
    if (dateNew[0] < 10) {
      dateNew[0] = '0' + dateNew[0]
    }
    dateNew = `${dateNew[2]}-${dateNew[1]}-${dateNew[0]}`

    clientAxios.post('/product-status/check-products-average-cleanup', {
      surveyDate: dateNew
    })
      .then(res => {
        console.log(res)
        if (res.status === 200) {
          sessionStorage.setItem('object', JSON.stringify(data))

          navigate('/products')
          // navigate('/survey-information')
        }
      })
      .catch(err => {
        console.log(err)
      })

    setError('')
  }

  return (
    <Stack alignItems={'center'} justifyContent={'center'} mx={'auto'}>
      <Box padding={4}>
        <Image
          alt='quilmes'
          h={'auto'}
          src={quilmesImages('./logo.svg')}
          w={'auto'}
        />
      </Box>
      <Divider />
      <Stack
        justifyContent='center'
        mx='auto'
        paddingTop={8}
        w={{ base: '90%', md: 400 }}
      >
        {isLargerThan768
          ? (
            <Heading fontSize={'24px'} fontWeight={400} textAlign='left'>
              Información del relevamiento
            </Heading>
          )
          : (
            <Heading fontSize={'26px'} fontWeight={400} textAlign='left'>
              Información del relevamiento
            </Heading>
          )}
        <VStack
          as={'form'}
          w={{ base: '100%', md: 400 }}
          onSubmit={handleSubmit}
        >
          <Stack paddingTop={6} w={{ base: '100%', md: 400 }}>
            {isLargerThan768
              ? (
                <SelectWeb
                  setData={setData}
                  setSurvey={setSurvey}
                  survey={survey}
                />
              )
              : (
                <>
                  <div className='floating-label'>
                    <DateDrawer setSurvey={setSurvey} sizes={sizes} survey={survey} />
                    {survey.date !== '' && (
                    <label className='label-select'>
                      <Text color={'#000'}>Fecha *</Text>
                    </label>
                    )}
                  </div>

                  <div className='floating-label'>
                    {sizes.map((sizeS) => (
                      <ListDistributor
                        key={sizeS}
                        setSurvey={setSurvey}
                        survey={survey}
                        title='Distribuidor'
                      />
                    ))}
                    {survey.distributor !== '' && (
                      <label className='label-select'>
                        <Text color={'#000'}>Distribuidor *</Text>
                      </label>
                    )}
                  </div>

                  {/*
                  <div className='floating-label'>
                    {sizes.map((size) => (
                      <ListArea
                        key={size}
                        setSurvey={setSurvey}
                        survey={survey}
                        title='Área'
                      />
                    ))}
                    {survey.area !== '' && (
                    <label className='label-select'>
                      <Text color={'#000'}>Área *</Text>
                    </label>
                    )}
                  </div>

                  <div className='floating-label'>
                    {sizes.map((size) => (
                      <ListBottler
                        key={size}
                        setSurvey={setSurvey}
                        survey={survey}
                        title='Embotellador'
                      />
                    ))}
                    {survey.bottler !== '' && (
                    <label className='label-select'>
                      <Text color={'#000'}>Embotellador *</Text>
                    </label>
                    )}
                  </div>
                  */}
                  <div className='floating-label'>
                    {sizes.map((size) => (
                      <ListChannel
                        key={size}
                        setSurvey={setSurvey}
                        survey={survey}
                        title='Canal'
                      />
                    ))}
                    {survey.channel !== '' && (
                    <label className='label-select'>
                      <Text color={'#000'}>Canal *</Text>
                    </label>
                    )}
                  </div>
                </>
              )}
          </Stack>

          {error && (
            <Stack paddingTop={'2'} w={'100%'}>
              <Text color='red.500' w='100%'>
                {error}
              </Text>
            </Stack>
          )}

          <Stack
            alignItems={'flex-start'}
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'flex-start'}
            paddingTop={4}
            w={'100%'}
          >
            <Button
              _focusVisible={{ outline: 'none' }}
              fontSize={'14px'}
              size={'md'}
              type='submit'
              variant={'btn-quilmes'}
              w={'50%'}
            >
              Continuar
            </Button>
          </Stack>
        </VStack>
      </Stack>
    </Stack>
  )
}

export default SurveyInformation
